module.exports = __webpack_public_path__ + "static/img/no-course.adf8981.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/no-course.png
// module id = jSM6
// module chunks = 7